import { useState } from "react";
import { CreditCard } from "lucide-react";
import { api, apiError } from "@/lib/api";
import { toast } from "sonner";

export default function StripePay({ orderNum, promoCode }) {
  const [loading, setLoading] = useState(false);
  const pay = async () => {
    setLoading(true);
    try {
      const { data } = await api.post("/payments/checkout", { order_num: orderNum, origin_url: window.location.origin, promo_code: promoCode || null });
      window.location.href = data.checkout_url;
    } catch (e) {
      toast.error(apiError(e.response?.data?.detail));
      setLoading(false);
    }
  };
  return (
    <button onClick={pay} disabled={loading} data-testid="stripe-pay-btn"
      className="w-full bg-white hover:bg-ape-muted text-black font-head uppercase tracking-widest py-4 flex items-center justify-center gap-2 transition-colors duration-150 disabled:opacity-50">
      <CreditCard size={18} /> {loading ? "Redirecting…" : "Pay with Card"}
    </button>
  );
}
